import {
  put,
  all,
} from 'redux-saga/effects';

import * as baseTypes from './base/types';
import * as existingIntegrationsTypes from './existingIntegrations/types';
import * as availableIntegrationsTypes from './availableIntegrations/types';
import * as integrationFormTypes from './integrationForm/types';

import { sagas as baseSagas } from './base';
import { sagas as existingIntegrationsSagas } from './existingIntegrations';
import { sagas as availableIntegrationsSagas } from './availableIntegrations';
import { sagas as integrationFormSagas } from './integrationForm';

function* init() {
  yield all([
    put({ type: baseTypes.INIT }),
    put({ type: existingIntegrationsTypes.INIT }),
    put({ type: availableIntegrationsTypes.INIT }),
    put({ type: integrationFormTypes.INIT }),
  ]);
}

export default [
  init,
  ...baseSagas,
  ...existingIntegrationsSagas,
  ...availableIntegrationsSagas,
  ...integrationFormSagas,
];
